import React from "react";

const WORDS = [
  "Protection",
  "Expertise",
  "Pérennité",
  "Prévoyance",
  "Discrétion",
  "Sur-mesure",
  "Indépendance",
  "Confiance",
];

export default function Marquee() {
  const items = [...WORDS, ...WORDS];
  return (
    <section aria-hidden className="relative overflow-hidden border-y border-[#0a192f]/10 bg-[#efeade]">
      <div className="marquee-track flex whitespace-nowrap py-6">
        {items.map((w, i) => (
          <div key={i} className="flex items-center gap-8 pr-8">
            <span className="font-serif text-3xl md:text-4xl italic text-[#0a192f]/80">
              {w}
            </span>
            <span className="text-[#c05c3d]">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
